import { message } from 'ant-design-vue'
import { customSignUp } from '~/server/common'
import { useUserInfoStore } from '~/stores/useUserInfo'
import { cancelFavorite, checkFavorite, saveFavorite } from '~/server/newhouse'

export function useCustomNeedLoginAction() {
  const store = useUserInfoStore()

  interface signUpParamType {
    businessId: number
    cityId: number
    source: string
    sourceTypeId: number
    mobile?: string
  }
  /**
   * 活动报名
   */
  function customCommonSignUp(params: signUpParamType) {
    return new Promise((resolve, reject) => {
      const func = customSignUp
      /**
       * if---检测有无用户信息，没有的话走获取用户信息的逻辑
       * else---有的话直接执行报名方法
       */
      if (!store.userInfo) {
        // store.getUserInfo().then((res: any) => {
        const userInfo = store.getUserInfo(true)
        if (!userInfo.mobile)
          return
        params.mobile = userInfo.mobile
        func(params).then((res) => {
          const { code, message: msg } = res
          if (code === 0) {
            message.success(msg)
            return resolve(res)
          }
          else {
            return reject(res)
          }
        })
        // })
      }
      else {
        params.mobile = store.userInfo?.mobile
        func(params).then((res) => {
          const { code, message: msg } = res
          if (code === 0) {
            message.success(msg)
            return resolve(res)
          }
          else {
            return reject(res)
          }
        })
      }
    })
  }

  /**
   * 收藏、加入喜欢
   */
  interface collectType {
    cityId: number // 城市ID
    numberId: number // 房源/楼盘ID/小区ID/户型ID
    sortId: number // 收藏类别ID --> 1：二手房；2：租房；3：小区；4：资讯；5：新房楼盘；6：新房户型；7：家装；8：新房房源；31：小区户型；71：建材公司；72：建材产品；73：装修案例
    averagePrice?: number // 均价
    buildArea?: number // 面积
    dataId?: number // 数据ID: 如房号/小区ID/楼盘ID
    floor?: string // 小区/楼盘名称
    houseFrame?: string // 户型
    housePic?: string // 房源图片
    price?: number // 总价/租金
    rentType?: number // 租赁方式: 1整租，2合租
    source?: number // 收藏来源 --> 1：PC端；2：app端；3：M版；4：小程序
    title?: string // 标题
    [property: string]: any
  }
  function handleSaveFavorite(params: collectType) {
    return new Promise((resolve, reject) => {
      params.source = 1
      const func = saveFavorite
      func(params).then((res) => {
        const { code, message: msg } = res
        if (code === 0) {
          message.success(msg)
          return resolve(res)
        }
        else {
          return reject(res)
        }
      })
    })
  }

  /**
   * 取消收藏
   */
  interface cancelFavoriteType {
    cityId: number // 城市ID
    dataId?: number // 数据ID: 如房号
    numberId: number // 房源/楼盘ID
    sortId: number // 收藏类别 --> 1：二手房；2：租房；3：小区；31：小区户型；4：资讯；5：新房楼盘；6：新房户型；7：家装；8：新房房源；71：建材公司；72：建材产品；73：装修案例
    [property: string]: any
  }
  function handleDeleteFavorite(params: cancelFavoriteType) {
    return new Promise((resolve, reject) => {
      const func = cancelFavorite
      func(params).then((res) => {
        const { code, message: msg } = res
        if (code === 0) {
          message.success(msg)
          return resolve(res)
        }
        else {
          return reject(res)
        }
      })
    })
  }

  /**
   * 是否收藏
   */
  interface isFavoriteType {
    cityId: number // 城市ID
    dataId?: number // 数据ID --> 房号ID or 楼盘ID or 小区ID
    numberId: number // 房源ID or 楼盘ID or 小区ID or 户型ID
    sortId: number // 收藏类别 --> 1：二手房；2：租房；3：小区；31：小区户型；4：资讯；5：新房楼盘；6：新房户型；7：家装；8：新房房源；71：建材公司；72：建材产品；73：装修案例
    [property: string]: any
  }
  function handleIsFavorite(params: isFavoriteType) {
    return new Promise((resolve, reject) => {
      const func = checkFavorite
      func(params).then((res) => {
        const { code } = res
        if (code === 0)
          return resolve(res)
        else
          return reject(res)
      })
    })
  }

  return { customCommonSignUp, handleSaveFavorite, handleDeleteFavorite, handleIsFavorite }
}
